import { render, staticRenderFns } from "./verifyemail.vue?vue&type=template&id=f881b744&scoped=true&"
import script from "./verifyemail.vue?vue&type=script&lang=js&"
export * from "./verifyemail.vue?vue&type=script&lang=js&"
import style0 from "./verifyemail.vue?vue&type=style&index=0&id=f881b744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f881b744",
  null
  
)

export default component.exports